module.exports = __webpack_public_path__ + "img/telephone_white.b82f5a8e.svg";